import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const UserStore = {
  namespaced: true,
  state: {
    users: [],
    services: []
  },
  getters,
  mutations,
  actions
}

export default UserStore
